// Module
var code = "<h3>Manage WillsOnline will narratives</h3> <div id=\"woElementsVersionPanel\" class=\"card mb-6\"> <div id=\"woElementsVersionContent\">Loading…</div> </div> <div id=\"woElementsContent\"></div> ";
// Exports
export default code;